export { ChatSparklesLottie } from './ChatSparklesLottie';
export type { ChatSparklesLottieProps } from './ChatSparklesLottie';
